import { render, staticRenderFns } from "./divSwiper.vue?vue&type=template&id=79f64398&scoped=true"
import script from "./divSwiper.vue?vue&type=script&lang=ts"
export * from "./divSwiper.vue?vue&type=script&lang=ts"
import style0 from "./divSwiper.vue?vue&type=style&index=0&id=79f64398&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f64398",
  null
  
)

export default component.exports